import { useNumberStore, useOrganizationStore, useUserStore } from 'store/modules';
import { SUSPENDED_BILLING_ROUTES } from './constants';

export default function (to, from, next) {
    const userStore = useUserStore();
    const numberStore = useNumberStore();
    const organizationStore = useOrganizationStore();

    if (to.name === 'force-password-change' || to.name === 'auth.reset') {
        return next();
    }
    const picker = window.Config.new_billing_registration
        ? organizationStore.isV2auth
            ? 'conversations'
            : 'register'
        : 'picker';

    const hasTwilioNumberVendorIntegration =
        numberStore.numberVendorIntegrations?.hasOwnProperty('twilio-integration');

    const isRequireNumber =
        userStore.isLoggedIn &&
        !numberStore.hasNumber &&
        !organizationStore.isAgency &&
        !userStore.isViewOnlyRole &&
        (hasTwilioNumberVendorIntegration
            ? !hasTwilioNumberVendorIntegration
            : userStore.user.isRequireNumber || userStore.user.isRequirePftNumber) &&
        !userStore.user.inboxesCount;

    if (
        isRequireNumber &&
        to.name !== picker &&
        !SUSPENDED_BILLING_ROUTES.includes(to.name) &&
        !SUSPENDED_BILLING_ROUTES.includes(to.path)
    ) {
        next({
            name: picker,
            query: to.query,
        });
    } else if (
        userStore.isLoggedIn &&
        !isRequireNumber &&
        to.name === picker &&
        to.name !== 'conversations'
    ) {
        next('/');
    } else {
        next();
    }
}
